import posAuthManager, { POS_AUTH_SESSION_KEYS } from "./posAuthManager";

const FRAGMENT_KEY = "s";

function logHandoffError(reason, context) {
  if (typeof window === "undefined") return;
  window.DD_RUM?.addError?.(new Error(`pos_handoff:${reason}`), context);
}

// btoa/atob only speak latin-1, so the string is walked through UTF-8 bytes
// first — TextEncoder/TextDecoder rather than the deprecated escape/unescape.
function encodeBase64Url(str) {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

function decodeBase64Url(str) {
  if (typeof str !== "string") return null;
  try {
    const padded = str + "==".slice((str.length + 2) % 4);
    const binary = atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch (e) {
    logHandoffError("decode_failed", { length: str.length });
    return null;
  }
}

export function buildSessionFragment() {
  const payload = {};
  for (const key of Object.values(POS_AUTH_SESSION_KEYS)) {
    const value = posAuthManager.get(key);
    if (value !== null && value !== undefined && value !== "") {
      payload[key] = value;
    }
  }
  if (Object.keys(payload).length === 0) return "";
  return `#${FRAGMENT_KEY}=${encodeBase64Url(JSON.stringify(payload))}`;
}

export function appendFragment(url, fragment) {
  if (!fragment) return url;
  const hashIndex = url.indexOf("#");
  const base = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
  return base + fragment;
}

export function parseSessionFragment(hash) {
  if (typeof hash !== "string" || !hash) return null;
  const clean = hash.startsWith("#") ? hash.slice(1) : hash;
  const params = new URLSearchParams(clean);
  const encoded = params.get(FRAGMENT_KEY);
  if (!encoded) return null;
  try {
    const parsed = JSON.parse(decodeBase64Url(encoded));
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (e) {
    logHandoffError("fragment_parse_failed", { length: encoded.length });
    return null;
  }
}

export function consumeSessionFragment() {
  if (typeof window === "undefined") return null;
  try {
    const payload = parseSessionFragment(window.location.hash);
    if (!payload) return null;
    posAuthManager.setMany(payload);
    try {
      const clean = window.location.pathname + window.location.search;
      window.history.replaceState(null, "", clean);
    } catch (e) {
      logHandoffError("replace_state_failed", { message: e?.message });
    }
    return payload;
  } catch (e) {
    logHandoffError("consume_failed", { message: e?.message });
    return null;
  }
}
